module.exports = __webpack_public_path__ + "media/images/country_flags/vn-6a82249b305a2d81b69949899ad88e2e.png";